import StoreChangeConfirm from 'component/StoreChangeConfirm';

export default class StoreManager {
    constructor() {
        this.$popup = $('.store-manager-popup');
        this.$searchResult = $('.store-manager-popup__search-result');
        this.$cityList = $('.store-manager-popup__city-list');
        this.$confirmPopup = $('.store-manager-confirm-popup');
        this.storeChangeConfirmPopup = new StoreChangeConfirm;
        this.storeChangeConfirmPopup.storeManagerPopup = this;
        this.bind();
    }

    bind() {
        $('.store-manager__link-block').on('click', this.show.bind(this));
        $('.store-manager-popup__city-item-link').on('click', this.popupCityClick.bind(this));
        $('.store-manager-popup__store-item-link').on('click', this.popupStoreClick.bind(this));
        $('.store-manager-popup__search-input').on('input', this.search.bind(this));
        $('.store-manager-confirm-popup__button--yes').on('click', this.confirmStore.bind(this));
        $('.store-manager-confirm-popup__button--no').on('click', this.chooseAnotherStore.bind(this));
        this.rebindCustomTrigger();
    }

    rebindCustomTrigger() {
        $('.store-manager-custom-trigger').off('click').on('click', this.show.bind(this));
    }

    show(e) {
        e && e.preventDefault();

        if (app.storeManager.disabled) {
            return;
        }

        this.$popup.modal('show');
    }

    popupCityClick(e) {
        e.preventDefault();

        const $el = $(e.currentTarget).closest('.store-manager-popup__city-item');
        const storeId = $el.attr('data-storeId');
        const cityId = $el.attr('data-id');

        if (storeId) {
            this.storeChangeConfirmPopup.setStoreData = {
                storeId: storeId,
                cityId: cityId,
            };
            this.storeChangeConfirmPopup.show();
            //this.setStore(cityId, storeId);
        }
    }

    popupStoreClick(e) {
        e.preventDefault();

        const storeId = $(e.currentTarget).attr('data-id');
        const cityId = $(e.currentTarget).closest('.store-manager-popup__city-item').attr('data-id');

        if (storeId) {
            this.storeChangeConfirmPopup.setStoreData = {
                storeId: storeId,
                cityId: cityId,
            };
            this.storeChangeConfirmPopup.show();
            //this.setStore(cityId, storeId);
        }
    }

    setStore(cityId, storeId) {
        var data = {
            ajax: 'Y',
            method: 'setCurrentStore',
            cityId: cityId,
            storeId: storeId,
        };

        if (window['yaCounter' + window.metrikaId]) {
            window['yaCounter' + window.metrikaId].reachGoal('changestore');

            window['yaCounter' + window.metrikaId].params({
                storeName: app.storeManager.stores[storeId].name
            });
        }

        $.ajax({
            url: document.location.href,
            data: data,
            dataType: 'json'
        }).done(data => {
            if (data.status == 'error') {
                alert(data.status);
                return;
            }

            document.location.reload();
        });
    }

    search(e) {
        const query = $(e.currentTarget).val();

        if (query.length > 0) {
            this.showSearchResult(query);
        } else {
            this.clearSearchResult();
        }
    }

    showSearchResult(query) {
        query = query.replace(/[^a-zа-я]/gi, '').toLowerCase();
        let result = [];

        for (let store of Object.values(app.storeManager.stores)) {
            if (store.name.toLowerCase().indexOf(query) === 0) {
                result.push(store);
            }
        }

        let html;

        if (result.length > 0) {
            result.sort((a, b) => {
                if (a.name == b.name) {
                    return 0;
                } else {
                    return a.name < b.name ? -1 : 1;
                }
            });

            html = result.map(store => `
                <div class="store-manager-popup__search-result-item">
                    <a class="store-manager-popup__search-result-item-link" data-storeId="${store.id}" data-id="${store.city}" href="#">${store.name}</a>
                </div>`
            ).join('');
        } else {
            html = `<div class="store-manager-popup__search-result-empty">Ничего не найдено</div>`;
        }

        this.$searchResult.html(html);
        $('.store-manager-popup__search-result-item-link').on('click', this.searchItemClick.bind(this));

        this.$searchResult.removeClass('hidden');
        this.$cityList.addClass('hidden');
    }

    clearSearchResult() {
        this.$searchResult.addClass('hidden');
        this.$cityList.removeClass('hidden');
    }

    searchItemClick(e) {
        e.preventDefault();
        const $el = $(e.currentTarget);
        const storeId = $el.attr('data-storeId');
        const cityId = $el.attr('data-id');

        if (storeId) {
            this.storeChangeConfirmPopup.setStoreData = {
                storeId: storeId,
                cityId: cityId,
            };
            this.storeChangeConfirmPopup.show();
            //this.setStore(cityId, storeId);
        }
    }

    confirmStore(e) {
        e.preventDefault();

        $.ajax({
            url: document.location.href,
            data: {
                ajax: 'Y',
                method: 'confirmCity'
            },
            dataType: 'json'
        }).done((data) => {
            if (data.status == 'error') {
                alert(data.status);
                return;
            }

            this.$confirmPopup.addClass('hidden');
        });
    }

    chooseAnotherStore(e) {
        e.preventDefault();

        this.$confirmPopup.addClass('hidden');
        this.show();
    }
}